module.exports = __webpack_public_path__ + "img/shisha-blue.670ec5dd.jpg";